import { Input, Popover } from "antd";
import { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleRouteNav } from "../../utils";

const SearchPopover = ({ open, setOpen, children }) => {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const { role_id } = useSelector((state) => state.auth);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && search) {
      setOpen(false);
      const to = handleRouteNav("/product-catalog", role_id);
      const params = new URLSearchParams({ q: search });
      navigate({
        pathname: to,
        search: params.toString(),
      });
    }
  };

  const content = (
    <div
      className="rounded-[20px] p-6"
      style={{
        background: "linear-gradient(50.53deg, #F4F4F4 36.74%, #FFDBD4 95.35%)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        minWidth: "400px",
      }}
    >
      <div className="flex justify-between items-start">
        <h2 className="font-abhaya text-[22px] text-[#000]">Search for a product</h2>
        <button
          onClick={() => setOpen(false)}
          className="w-[32px] h-[32px] rounded-lg border border-[#ddd] flex items-center justify-center bg-[#FFFFFF] opacity-40"
        >
          <IoClose size={18} />
        </button>
      </div>

      <Input
        size="large"
        placeholder="Search for a product"
        prefix={<AiOutlineSearch size={18} style={{ color: "#A0A0A0" }} />}
        className="search-input mt-3"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );

  return (
    <>
      <Popover
        content={content}
        trigger="click"
        open={open}
        onOpenChange={setOpen}
        placement="bottomRight"
        styles={{
          body: { padding: 0, background: "transparent", borderRadius: 20 },
        }}
        arrow={false}
        classNames={{
          root: "custom-popover",
        }}
      >
        {children}
      </Popover>
    </>
  );
};

export default SearchPopover;
